module.exports = __webpack_public_path__ + "static/facebok-open-graph@2x.1c12715a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebok-open-graph@2x.png
// module id = 181
// module chunks = 35783957827783 43201937662106